export default "__VITE_ASSET__CZV596DC__"